export default {
  path: 'winter-service/v2/work-orders/overview/:id',
  name: 'WinterService2WorkOrderDetails',
  component: () => import(/* webpackChunkName: "road-maintenance" */ '../views/WorkOrderDetails.vue')
}
